import * as React from 'react';

export interface IAuthSubtitleProps {
  subtitle: string | JSX.Element;
  width?: string;
}

export default function AuthSubtitle(props: IAuthSubtitleProps) {
  const { subtitle, width = '10/12' } = props;
  return (
    <p className={`text-base text-gray-light w-10/12 w-${width}`}>{subtitle}</p>
  );
}
